import style from '../TaskSection.module.scss';

interface Props {
    title: string;
    action?: React.ReactNode;
}

export function TaskSectionTitle({ title, action }: Props): React.ReactElement<any> {
    return (
        <div className={style.title}>
            <div className={'font_h3'}>{title}</div>
            {action}
        </div>
    );
}
